const quasarKey = "_q_";
const formKey = "_q_fo_";
export {
  formKey,
  quasarKey
};
//# sourceMappingURL=symbols.es.js.map
